<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-confirmar-cancelamento [confirmarCancelamento]="confirmaCancelamento" (confirmarCancelamentoFechou)="respostaConfirmacao($event)"></app-confirmar-cancelamento>

<div class="container py-4">
  <div class="row">
    <div class="col-12">

      @if (statusApi == 'sucesso') {
        <div class="card card-status-api sucesso mb-3">
          <div class="div-item">
            <i class="fa fa-check icone-check c-primary float-start icone-padrao" aria-hidden="true"></i>
          </div>
          <button class="btn-icon" (click)="fecharStatusApi()">
            <i class="fa fa-close float-end c-primary" aria-hidden="true"></i>
          </button>
          <h4 class="titulo-status-api">Pedido(s) cancelado(s) :)</h4>
          <p class="legenda">Seu(s) pedido(s) cancelado(s) com sucesso!</p>
        </div>
      }

      @if (statusApi == 'erro') {
        <div class="card card-status-api erro mb-3">
          <div class="div-item">
            <i class="fa fa-warning icone-check c-danger float-start icone-padrao" aria-hidden="true"></i>
          </div>
          <button class="btn-icon" (click)="fecharStatusApi()">
            <i class="fa fa-close float-end c-danger" aria-hidden="true"></i>
          </button>
          <h4 class="titulo-status-api">Ocorreu um erro</h4>
          <p class="legenda">Ocorreu um erro ao cancelar os pedidos, por favor tente novamente.</p>
        </div>
      }

      @if (statusApi == 'carregando') {
        <div class="card card-status-api carregando mb-3">
          <div class="div-item float-end">
            <output class="spinner-border c-primary d-block">
              <span class="visually-hidden">loading ...</span>
            </output>
          </div>
          <h4 class="titulo-status-api">Por favor aguarde ...</h4>
          <p class="legenda">Cancelamento de pedidos sendo processado.</p>
        </div>
      }

      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Cancelamento de Pedidos
          <button class="btn-icon" (click)="goBackPage()" >
            <i class="fa fa-arrow-left botao-setinha-voltar" aria-hidden="true"></i>
          </button>
        </h1>
        <p class="paragrafo mb-4">Selecione um ou mais pedidos para cancelamento.
        </p>
        <!-- TABELAS -->
        <!-- TABELA COM OS PEDIDOS -->
        @if (pedidosPraCancelar) {
          <table class="table table-hover table-responsive border-bottom" aria-describedby="tabela de pedidos para cancelar">
            <thead>
              <tr>
                <th scope="col" class="border-top-0">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="selecionaTodosPedidos"
                      (change)="selecionaTodos($event.target)"
                      >
                    <label class="form-check-label" for="selecionaTodosPedidos"> </label>
                  </div>
                </th>
                <th scope="col" class="border-top-0"></th>
                <th scope="col" class="border-top-0">PEDIDO</th>
                <th scope="col" class="border-top-0">EMISSÃO</th>
                <th scope="col" class="border-top-0">PAGAMENTO</th>
                <th scope="col" class="border-top-0">ENTREGA</th>
                <th scope="col" class="border-top-0">VALOR TOTAL</th>
                <th scope="col" class="border-top-0">FINANCEIRO</th>
                <th scope="col" class="border-top-0">OPERACIONAL</th>
                <th scope="col" class="border-top-0">RECARGA CERTA</th>
                <th scope="col" class="border-top-0">TIPO DO PEDIDO</th>
              </tr>
            </thead>
            <tbody>
              <!-- LOOP PARA CADA PEDIDO -->
              @for (pedido of pedidosPraCancelar; track pedido; let i = $index) {
                <tr>
                  <td class="pt-2">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="{{pedido.idPedido}}"
                        title="{{pedido.idPedido}}"
                        name="inputsCancelamento"
                        [attr.aria-label]="'Selecionar pedido ' + pedido.idPedido"
                        >
                      <label class="form-check-label" for="{{pedido.idPedido}}"></label>
                    </div>
                  </td>
                  <td class="text-center">
                    <button
                      id="btnDetalhar{{i}}"
                      (click)="detalharPedido(pedido.idPedido, pedido.idEmpresa)"
                      data-bs-toggle="tooltip"
                      data-placement="top"
                      title="Clique para detalhar o pedido"
                      class="btn-icon"
                      >
                      <i class="fa fa-plus-circle icone" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td>{{pedido.idPedido}}</td>
                  <td>Não consta</td>
                  <!-- DATA PAGAMENTO -->
                  @if (pedido.dataPagamentoPrevisto) {
                    <td>{{pedido.dataPagamentoPrevisto | appDate: 'dd/MM/yyyy'}}</td>
                  }
                  @if (!pedido.dataPagamentoPrevisto) {
                    <td>Não consta</td>
                  }
                  <!-- DATA ENTREGA -->
                  @if (pedido.dataPrevisaoEntrega) {
                    <td>{{pedido.dataPrevisaoEntrega | appDate: 'dd/MM/yyyy'}}</td>
                  }
                  @if (!pedido.dataPrevisaoEntrega) {
                    <td>Não consta</td>
                  }
                  <td class="text-nowrap">{{pedido.valorPedido | currency: 'BRL'}}</td>
                  <td>{{pedido.flagFase}}</td>
                  <td><span [ngClass]="{ 'status-pago': pedido.flagStatus == 'Pago', 'status-a-pagar': pedido.flagStatus == 'A Pagar', 'status-liberado': pedido.flagStatus == 'Lib. Produção'}">{{pedido.flagStatus}}</span></td>
                  <td>Não consta</td>
                  <td>{{pedido.descTipoPedido}}</td>
                </tr>
              }
            </tbody>
          </table>
        }

        @if (mensagemErro) {
          <div class="row ps-3">
            <p class="legenda-erro">{{mensagemErro}}</p>
          </div>
        }


        <!-- BOTÕES BAIXAR -->
        @if (pedidosPraCancelar) {
          <div class="row text-center">
            <button class="botao-erro-outline mx-auto mt-4 ajuste-botao" id="btnCancelarPedidosSelecionados" (click)="confirmacaoCancelamento()">CANCELAR PEDIDOS SELECIONADOS</button>
            <button class="botao-outline mx-auto mt-4 ajuste-botao" id="btnVoltarTodosPedidos" routerLink="/listar-pedidos">VOLTAR PARA TODOS OS PEDIDOS</button>
          </div>
        }

        <!-- CARREGAMENTO EMPRESAS -->
        @if (pedidosPraCancelar === null) {
          <div>
            <div class="text-center">
              <output class="spinner-border c-primary">
                <span class="visually-hidden">Consultando dados sobre pedidos ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Consultando dados sobre pedidos ...</p>
          </div>
        }

        <!-- CASO DE ERRO EMPRESAS -->
        @if (pedidosPraCancelar === false) {
          <div class="text-center">
            <img src="/assets/img/erro.png" width="200px" alt="mensagem de erro">
            <p class="legenda-erro">Ocorreu um erro na consulta da lista de pedidos.</p>
          </div>
        }

        <!-- Pedidos vazios -->
        @if (pedidosPraCancelar === undefined) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" width="230px" alt="nao existem pedidos para cancelar">
            <p class="legenda-vazio">Não existem pedidos para cancelar no momento.</p>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
